var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

export default isEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/events/isEvent.js
// module id = 427
// module chunks = 0